import React from 'react';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import createImageUrl from '../helpers/createImageUrl';

const getAlt = (image, {
  alt,
  fallbackAlt,
}) => {
  if (alt) {
    return alt;
  }
  if (image.altText) {
    return image.altText;
  }
  if (image.alternativeText) {
    return image.alternativeText;
  }
  if (image.gatsbyImage?.name) {
    return image.gatsbyImage.name;
  }
  if (image.name) {
    return image.name;
  }
  if (fallbackAlt) {
    return fallbackAlt;
  }
  return '';
};

const Image = ({
  className,
  image,
  options = [],
  alt,
  fallbackAlt = undefined,
  preferRemote = false,
  ...props
}) => {
  if (!image) {
    return null;
  }

  const alternativeText = getAlt(image, {
    alt,
    fallbackAlt,
  });
  const showRemoteImage = preferRemote && image.url;

  if (!showRemoteImage && image.gatsbyImage) {
    return (
      <GatsbyImage
        className={className}
        image={image.gatsbyImage}
        alt={alternativeText}
        {...props}
      />
    );
  }

  if (!showRemoteImage && getImage(image.localFile)) {
    return (
      <GatsbyImage
        className={className}
        image={getImage(image.localFile)}
        alt={alternativeText}
        {...props}
      />
    );
  }

  if (image.url) {
    return (
      <img
        className={className}
        src={createImageUrl({
          url: image.url,
          options: [...options, 'dpr_2.0', 'c_fill'],
        })}
        alt={alternativeText}
        width={image.width}
        height={image.height}
        css="max-width: 100%; height: auto;"
        {...props}
      />
    );
  }

  console.warn('Rendered nothing in Image component');
  console.table(image);
  return null;
};

export default styled(Image)``;
